import Number from '@/models/creditCard/number';

export default (value: string): boolean => Number.isValid(value);
